import { useKernelApi } from 'infrastructure/api';

const EMPLOYEE_GROUP_PATH = '/groups';

const useEmployeeGroupService = () => {
  const { sendGetRequest } = useKernelApi();
  const getAll = async () => {
    const response = await sendGetRequest(`${EMPLOYEE_GROUP_PATH}`);

    return response.json();
  };

  return {
    getAll,
  };
};

export default useEmployeeGroupService;
